import { Table, TableCell, TableHeaderCell, TableHeaderRow, TableRow } from '@pickleballinc/features/src/table';

export const TeamInfoTableSkeleton = () => {
	return (
		<div className="flex w-full flex-col py-8">
			<Table className="bg-white">
				<thead>
					<TableHeaderRow className="h-8">
						<TableHeaderCell />
						<TableHeaderCell />
						<TableHeaderCell />
						<TableHeaderCell />
						<TableHeaderCell />
						<TableHeaderCell />
					</TableHeaderRow>
				</thead>
				<tbody>
					<TeamsRow />
					<TeamsRow />
					<TeamsRow />
					<TeamsRow />
					<TeamsRow />
					<TeamsRow />
				</tbody>
			</Table>
		</div>
	);
};

const TeamsRow = () => {
	return (
		<TableRow className="h-16 text-xs font-normal text-gray-900">
			<TableCell className="flex items-center gap-2 text-sm font-semibold text-primary-500">
				<div className="size-12 animate-pulse rounded-full bg-gray-200" />
				<div className="h-6 w-24 animate-pulse rounded-md bg-gray-200" />
			</TableCell>
			<TableCell>
				<div className="h-3 w-6 animate-pulse rounded-md bg-gray-200" />
			</TableCell>
			<TableCell>
				<div className="h-3 w-6 animate-pulse rounded-md bg-gray-200" />
			</TableCell>
			<TableCell>
				<div className="h-3 w-6 animate-pulse rounded-md bg-gray-200" />
			</TableCell>
			<TableCell>
				<div className="h-3 w-6 animate-pulse rounded-md bg-gray-200" />
			</TableCell>
			<TableCell>
				<div className="h-3 w-6 animate-pulse rounded-md bg-gray-200" />
			</TableCell>
			<TableCell>
				<div className="h-3 w-6 animate-pulse rounded-md bg-gray-200" />
			</TableCell>
			<TableCell>
				<div className="h-3 w-6 animate-pulse rounded-md bg-gray-200" />
			</TableCell>
			<TableCell>
				<div className="h-7 w-16 animate-pulse rounded-md bg-gray-200" />
			</TableCell>
		</TableRow>
	);
};
